import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../services/apiServices";

const initialState = {
    rfqs: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
};

// Async Thunks
export const fetchRFQs = createAsyncThunk(
    "rfq/fetchRFQs",
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiServices.get("/rfq");
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const createRFQ = createAsyncThunk(
    "rfq/createRFQ",
    async (rfqData, { rejectWithValue }) => {
        try {
            const response = await apiServices.post("/rfq", rfqData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const updateRFQ = createAsyncThunk(
    "rfq/updateRFQ",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await apiServices.put(`/rfq/${id}`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const deleteRFQ = createAsyncThunk(
    "rfq/deleteRFQ",
    async (id, { rejectWithValue }) => {
        try {
            await apiServices.delete(`/rfq/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const updateRFQStatus = createAsyncThunk(
    "rfq/updateStatus",
    async ({ id, status }, { rejectWithValue }) => {
        try {
            const response = await apiServices.patch(`/rfq/${id}/status`, { status });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Slice
const rfqSlice = createSlice({
    name: "rfq",
    initialState,
    reducers: {
        resetStatus: (state) => {
            state.status = "idle";
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchRFQs.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchRFQs.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.rfqs = action.payload;
            })
            .addCase(fetchRFQs.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            // Create
            .addCase(createRFQ.fulfilled, (state, action) => {
                state.rfqs.unshift(action.payload); // Add to top
            })
            // Update
            .addCase(updateRFQ.fulfilled, (state, action) => {
                const index = state.rfqs.findIndex((r) => r._id === action.payload._id);
                if (index !== -1) {
                    state.rfqs[index] = action.payload;
                }
            })
            // Delete
            .addCase(deleteRFQ.fulfilled, (state, action) => {
                state.rfqs = state.rfqs.filter((r) => r._id !== action.payload);
            })
            // Status Update
            .addCase(updateRFQStatus.fulfilled, (state, action) => {
                const index = state.rfqs.findIndex((r) => r._id === action.payload._id);
                if (index !== -1) {
                    state.rfqs[index] = action.payload;
                }
            });
    },
});

export const { resetStatus } = rfqSlice.actions;
export default rfqSlice.reducer;
